export { generateTypeScript } from './generateTypeScript';
export { generateSubsetSchema, generateJsonSchemaString } from './generateJsonSchema';
export { generateOpenApiComponent, generateOpenApiString } from './generateOpenApi';
export { generateJsonTemplate, generateTemplateUsageExample } from './generateTemplate';

export function downloadFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
